export interface IQueue {
    // id: number;
    key: string;
    url: string;
    message?: string;
    body?: string;
}
